import axios from 'axios'
import { callToaster } from './helpers'
import { toast } from 'react-toastify'
import { handleErrors } from './handleErrors'
import store from '../store/index'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 900000,
})

instance.interceptors.response.use(
  response => response,
  error => {
    let errorsHandled = handleErrors(error)
    if (!errorsHandled) {
      // Network Error.
      callToaster(toast.TYPE.ERROR, 'Something Went Wrong')
      return Promise.reject({ message: 'Network Error' })
    }
    return Promise.reject({ message: 'Network Error' })
  }
)

const getRequest = (url, params = undefined) => {
  return instance
    .get(url, {
      params: params || null,
      headers: {
        'Content-Type': 'application/json',
        'Organization-Key': store.getState().general.organizationKey,
        'Organization-Slug': store.getState().general.organizationSlug,
        'Organization-Client': store.getState().general.organizationClientSlug,
        'Organization-Intro-Type': store.getState().general.introType,
        'Organization-Mode':
          store.getState().general.widgetMode === 'search'
            ? store.getState().general.widgetMode
            : 'chat',
        'Organization-Url': window.location.href,
        language: store.getState().general.language,
      },
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err
    })
}

const postRequest = (url, body) => {
  return instance
    .post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        'Organization-Key': store.getState().general.organizationKey,
        'Organization-Slug': store.getState().general.organizationSlug,
        'Organization-Client': store.getState().general.organizationClientSlug,
        'Organization-Intro-Type': store.getState().general.introType,
        'Organization-Mode':
          store.getState().general.widgetMode === 'search'
            ? store.getState().general.widgetMode
            : 'chat',
        'Organization-Url': window.location.href,
        language: store.getState().general.language,
      },
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err
    })
}

const deleteRequest = url => {
  return instance
    .delete(url, {
      headers: {
        'Content-Type': 'application/json',
        'Organization-Key': store.getState().general.organizationKey,
        'Organization-Slug': store.getState().general.organizationSlug,
        'Organization-Client': store.getState().general.organizationClientSlug,
        'Organization-Intro-Type': store.getState().general.introType,
        'Organization-Mode':
          store.getState().general.widgetMode === 'search'
            ? store.getState().general.widgetMode
            : 'chat',
        'Organization-Url': window.location.href,
        language: store.getState().general.language,
      },
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err
    })
}

const updateRequest = (url, body) => {
  return instance
    .put(url, body, {
      headers: {
        'Content-Type': 'application/json',
        'Organization-Key': store.getState().general.organizationKey,
        'Organization-Slug': store.getState().general.organizationSlug,
        'Organization-Client': store.getState().general.organizationClientSlug,
        'Organization-Intro-Type': store.getState().general.introType,
        'Organization-Mode':
          store.getState().general.widgetMode === 'search'
            ? store.getState().general.widgetMode
            : 'chat',
        'Organization-Url': window.location.href,
        language: store.getState().general.language,
      },
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err
    })
}

export default {
  getRequest,
  postRequest,
  deleteRequest,
  updateRequest,
}
